import {
  CreateWhiteSellerRequestInterface,
  DeleteWhiteSellerRequestInterface,
  UpdateWhiteSellerRequestInterface
} from '@/data/payload/contracts/WhiteSellerRequest'

export class CreateWhiteSellerApiRequest implements CreateWhiteSellerRequestInterface {
  public sellerName?: string
  public sellerPhone?: string
  public agentId?: number[]
  public sellerRole?: string
  public status?: string
  public codHandling?: string
  public courierId?: number
  public assignType?: string
  public clientId?: number
  public pcaIds?: number[]

  constructor(
    sellerName?: string,
    sellerPhone?: string,
    agentId?: number[],
    sellerRole?: string,
    status?: string,
    codHandling?: string,
    courierId?: number,
    assignType?: string,
    clientId?: number,
    pcaIds?: number[]
  ) {
    this.sellerName = sellerName
    this.sellerPhone = sellerPhone
    this.agentId = agentId
    this.sellerRole = sellerRole
    this.status = status
    this.codHandling = codHandling
    this.courierId = courierId
    this.assignType = assignType
    this.clientId = clientId
    this.pcaIds = pcaIds
  }

  public toPayload(): string {
    const data = {
      seller_name: this.sellerName,
      seller_phone: this.sellerPhone,
      agent_id: this.agentId || undefined,
      seller_role: this.sellerRole,
      status: this.status,
      cod_handling: this.codHandling,
      courier_id: this.courierId || undefined,
      assign_type: this.assignType || undefined,
      client_id: this.clientId || undefined,
      // de-duplicated by pca_id; omitted when empty
      pca_ids:
        this.pcaIds && this.pcaIds.length
          ? Array.from(new Set(this.pcaIds))
          : undefined,
    }
    return JSON.stringify({
      ...data,
    })
  }
}

export class UpdateWhiteSellerApiRequest implements UpdateWhiteSellerRequestInterface {
  public id?: number
  public name?: string
  public phone?: string
  public status?: string
  public agentId?: number[]
  public role?: string
  public codHandling?: string
  public courierId?: number
  public assignType?: string
  public clientId?: number
  public pcaIds?: number[]

  constructor(
    id?: number,
    name?: string,
    phone?: string,
    status?: string,
    agentId?: number[],
    role?: string,
    codHandling?: string,
    courierId?: number,
    assignType?: string,
    clientId?: number,
    pcaIds?: number[]
  ) {
    this.id = id
    this.name = name
    this.phone = phone
    this.status = status
    this.agentId = agentId
    this.role = role
    this.codHandling = codHandling
    this.courierId = courierId
    this.assignType = assignType
    this.clientId = clientId
    this.pcaIds = pcaIds
  }

  public toPayload(): string {
    const data = {
      id: this.id,
      name: this.name,
      phone: this.phone || undefined,
      status: this.status,
      agent_id: this.agentId,
      role: this.role,
      cod_handling: this.codHandling,
      courier_id: this.courierId,
      assign_type: this.assignType,
      client_id: this.clientId || undefined,
      pca_ids:
        this.pcaIds && this.pcaIds.length
          ? Array.from(new Set(this.pcaIds))
          : undefined,
    }
    return JSON.stringify({
      ...data,
    })
  }
}

export class DeleteWhiteSellerApiRequest implements DeleteWhiteSellerRequestInterface {
  public ids?: number[]

  constructor(ids?: number[]) {
    this.ids = ids
  }

  public toPayload(): string {
    return JSON.stringify({ ids: this.ids })
  }
}

export class ShowSellerPhoneRequest {
  id = 0;
  type = "";
  source = ""

  constructor(fields?: Partial<ShowSellerPhoneRequest>) {
    Object.assign(this, fields);
  }
}
